import { Link } from 'react-router-dom';
import { hotDeals } from '@/mocks/data';

const HotDealsSection: React.FC = () => {
  const displayedDeals = hotDeals.slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              🔥 精选热门福利
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              限时优惠，手慢无！每日更新超值福利
            </p>
          </div>
          <Link
            to="/category/xianshi-miaosha"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {displayedDeals.map((deal) => (
            <Link
              key={deal.id}
              to={`/article/${deal.id}`}
              className="group bg-white rounded-xl border border-background-200 hover:border-primary-200 hover:shadow-md transition-all duration-300 overflow-hidden cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={deal.image}
                  alt={deal.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {deal.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-bold rounded whitespace-nowrap">
                    {deal.discount}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {deal.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2">
                  {deal.description}
                </p>
                <div className="mt-auto flex items-center justify-between">
                  <div className="flex items-baseline gap-1.5">
                    <span className="text-lg font-bold text-primary-600">
                      ¥{deal.currentPrice}
                    </span>
                    {deal.originalPrice > 0 && (
                      <span className="text-xs text-foreground-400 line-through">
                        ¥{deal.originalPrice}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{deal.expiresIn}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HotDealsSection;